import React, { useState, useContext, useEffect } from 'react';
import { ToggleButton, ButtonToolbar, ToggleButtonGroup, Spinner } from 'react-bootstrap';
import { useSelector, shallowEqual /*,useDispatch*/ } from 'react-redux'
import { Formik, Field, Form, ErrorMessage } from 'formik';
//import * as actionsPasoDos from "../_redux/pasoDos/pasoDosActions";
import * as Yup from 'yup';
import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../PreInscripcionUIContext';
import * as _ from 'lodash';

//BOTONES
import Volver from '../components/Volver';
import Continuar from '../components/Continuar';
import { func } from 'prop-types';

const Nivel = (props) => {
    //const dispatch = useDispatch();
    const { niveles } = useContext(PreInscripcionUIContext);
    const { pasoDos, llamado } = useSelector(
        (state) => ({ pasoDos: state.pasoDos, llamado: state.llamado }),
        shallowEqual
    );
    const {
        establecimientos,
        actionsLoading,
        //error: errorPaso2
    } = pasoDos;

    const {
        entities: llamados,
        actionsLoading: llamadosListLoading,
        error: errorLlamados
    } = llamado;

    
    const [nivelesFromState, setNivelesFromState] = useState();
    useEffect(() => {
        const aux = llamados && _.filter(niveles, function(nivel){
            return _.some(llamados, function (llamado) {
                return llamado.nivelEnsenanza == nivel.nivel && _.some(nivel.grados, function (grado) {
                    return true; //llamado.curso == grado;      //comentado porque no esta trayendo los grados
                });
            });
        });
        setNivelesFromState(aux);
    }, [llamados, niveles]);

    
    
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const valoresIniciales = establecimientos && establecimientos.length > 0 ?
        {
            nivel: establecimientos[0].nivelEnsenanza,
            grado: establecimientos[0].curso
        }
        :
        { nivel: "", grado: "" };
    const [detalleNivel, setDetalleNivel] = useState(0);

    const nivelSchema = Yup.object().shape({
        nivel: Yup.string()
            .required("Debe seleccionar un nivel de enseñanza"),
        grado: Yup.string()
            .required("Debe seleccionar un nivel de enseñanza y luego un Grado / Año"),
    });

    function SetNivel(formik, item, index) {
        /*if (establecimientos.length > 0) {
            dispatch(actionsPasoDos.stateLimpiar());
            value.dispatchDatosPeronales({ type: 'guardarEstablecimientos', payload: { establecimientos: [] } });
        };*/
        formik.setFieldValue("nivel", item.nivel);
        setDetalleNivel(index);
        formik.setFieldValue("grado", item.grados[0]);
    }

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {value.dispatchDatosPeronales({ type: 'calcularEdad' })}
                    <h3 className="text-center" >NIVEL</h3>
                    <div className="d-flex flex-row justify-content-between">
                        <div className="d-flex flex-row">
                            <p className="pr-5"><b >Edad del aspirante:</b> {value.stateDatosPersonales.aspirante.edad} años</p>
                            <p className="pl-5"><b >Nivel Recomendado:</b> {value.recomendacionInscripcion()}</p>
                        </div>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>
                    {!nivelesFromState || !valoresIniciales ?
                        <div className="text-success font-weight-bold text-center mb-4"> Obteniendo su información <Spinner animation="border" variant="success" /> </div>
                        :
                        <>
                            <Formik
                                enableReinitialize={true}
                                initialValues={valoresIniciales}
                                validationSchema={nivelSchema}
                                onSubmit={(values, { setSubmitting }) => {
                                    scrollTop();
                                    setTimeout(() => {
                                        //console.log(values);
                                        value.dispatchDatosPeronales({ type: 'guardarNivelEnseñanza', payload: values });
                                        props.nextStep();
                                        setSubmitting(false);
                                    }, 400);
                                }}
                            >
                                {formik => (
                                    <Form>
                                        <label htmlFor="nivel">Seleccione Nivel de Enseñanza*</label>
                                        
                                        <div className="form-group mt-5">
                                            <ButtonToolbar className="d-flex justify-content-center" >
                                                <ToggleButtonGroup type="radio" id="nivel" name="nivel" defaultValue={"Inicial"} value={formik.values.nivel}>
                                                    {/**HASTA EL 16/12 NO DEBE SALIR INSCRIPCION A SECUNDARIAS */}
                                                    {nivelesFromState && nivelesFromState.map((item, i) =>
                                                        <ToggleButton style={{ maxWidth: '25vh', minWidth: '12vh' }} size="sm"
                                                            key={i}
                                                            value={item.nivel}
                                                            defaultValue={item.nivel}
                                                            onClick={() => SetNivel(formik, item, i)}
                                                            //checked={nivelesFromState.length === 1}
                                                        >
                                                            {item.nivel}
                                                        </ToggleButton>
                                                    )}
                                                </ToggleButtonGroup>
                                            </ButtonToolbar>
                                            <div className="text-danger text-center"><ErrorMessage name="nivel" /></div>
                                        </div>
                                    
                                        <div className="form-group">
                                            <label htmlFor="grado">Seleccione Grado / Año*</label>
                                            <Field name="grado" className="form-control" as="select" disabled={!formik.values.nivel || formik.values.nivel.length === 0}>
                                                {formik.values.grado.length === 0 && <option value="">Grado / Año</option>}
                                                {
                                                    nivelesFromState[detalleNivel].grados.map((grado, i) => 
                                                        <option value={grado} key={i + 15} selected={nivelesFromState[detalleNivel].grados.length === 1}>
                                                            {formik.values.nivel === "Inicial" ? grado : "1º Año de " + formik.values.nivel}
                                                        </option>
                                                    )
                                                }
                                            </Field>
                                            <div className="text-danger"><ErrorMessage name="grado" /></div>
                                        </div>

                                        <div className="row justify-content-center">
                                            <Volver ultimoPaso={3} {...props} />
                                            <Continuar tipo="continuar" />
                                        </div>
                                            
                                    </Form>
                                )}
                            </Formik>
                        </>
                    }
                </>
            }
        </PreInscripcionUIConsumer >
    )
}

export default Nivel;